import React from 'react';
import {
    AppBar as MuiAppBar,
    Toolbar,
    Typography,
    Badge,
    IconButton,
    Select,
    MenuItem
} from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import MenuIcon from '@mui/icons-material/Menu';
import { useTranslation } from 'react-i18next';

const AppBar = ({ customerName, cartCount, onCartClick, onOpenCatalog, bgColor, fgColor, loading = false }) => {
    const { t, i18n } = useTranslation();

    const handleChangeLang = (e) => {
        i18n.changeLanguage(e.target.value);
    };

    return (
        <MuiAppBar
            position="sticky"
            sx={{
                top: 0,
                zIndex: 1100,
                backgroundColor: bgColor || 'primary.main',
                color: fgColor || '#fff',
            }}
        >
            <Toolbar>
                {/* Chapdagi menyu tugma */}
                <IconButton color="inherit" edge="start" onClick={onOpenCatalog} sx={{ mr: 1 }}>
                    <MenuIcon />
                </IconButton>

                {/* Til tanlash */}
                <Select
                    value={i18n.language}
                    onChange={handleChangeLang}
                    variant="standard"
                    sx={{
                        color: 'inherit',
                        mr: 2,
                        '& .MuiSelect-icon': { color: 'inherit' },
                    }}
                >
                    <MenuItem value="uz">🇺🇿 UZ</MenuItem>
                    <MenuItem value="ru">🇷🇺 RU</MenuItem>
                    <MenuItem value="en">🇬🇧 EN</MenuItem>
                </Select>

                <Typography variant="h6" sx={{ flexGrow: 1 }}>
                    {customerName ? t('greeting', { name: customerName }) : t('products')}
                </Typography>

                <IconButton color="inherit" onClick={onCartClick}>
                    <Badge badgeContent={cartCount} color="error">
                        <ShoppingCartIcon />
                    </Badge>
                </IconButton>

                {loading ? (
                    <span style={{ marginLeft: 12, opacity: 0.8, fontSize: 12 }}>…loading</span>
                ) : null}
            </Toolbar>
        </MuiAppBar>
    );
};

export default AppBar;
